import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { IHttpErrorResponseObject } from '@shared-interfaces/error';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(
    private readonly toastr: ToastrService,
    private readonly apiService: ApiService,
  ) {}

  public info(message: string, title?: string): void {
    this.toastr.info(message, title);
  }

  public success(message: string, title?: string): void {
    this.toastr.success(message, title);
  }

  public warning(message: string, title?: string): void {
    this.toastr.warning(message, title);
  }

  public error(friendlyMessage: string, title = 'Error', serverError?: IHttpErrorResponseObject, url?: string): void {
    this.toastr.error(friendlyMessage, title);

    //Create a TimberTrap
    this.apiService.logError$(friendlyMessage, serverError, url).subscribe({
      error: (response) => {
        console.error('Logged error:', response);
      },
    });
  }
}
